import { firebase } from "../firebase/firebase";

export const login = uid => ({
  type: "LOGIN",
  uid,
});

export const startLogin = (email, password) => {
  return () => {
    return firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        location.href = "/admin";
      })
      .catch(err => {
        alert("Nem sikerlüt bejelentkezni! \n" + err.message);
      });
  };
};

export const logout = () => ({
  type: "LOGOUT",
});

export const startLogout = () => {
  return () => {
    return firebase.auth().signOut();
  };
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js